import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TrackingService} from '../../services/tracking.service';
import {SpinnerService} from '../../services/spinner.service';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css']
})
export class TrackingComponent implements OnInit, OnDestroy {
  currentLanguage: string;
  errorMessage: string;
  deliveryMessage: string;
  estimatedDeliveryMessage: string;
  deliveryDateFrom: Date;
  deliveryDateTo: Date;
  height: number;
  truckNumber: string;
  orderNumber: number;
  hasError = false;
  isDelivered = false;
  lat: number;
  lng: number;
  zoom = 15;
  usePanning = true;
  disableUi = true;
  motrackingInterval: any;
  motrackingIntervalTime = 30 * 1000;
  deliveryStatusInterval: any;
  deliveryStatusIntervalTime = 5 * 60 * 1000;
  mapStyle: any[] = [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }
  ];
  mapType = 'hybrid';

  constructor(private readonly router: ActivatedRoute,
              private readonly spinnerService: SpinnerService,
              private readonly trackingService: TrackingService) { }

  ngOnInit(): void {
    this.currentLanguage = this.setLanguage();
    this.setMessages();
    this.height = window.innerHeight;
    this.spinnerService.busy();
    this.truckNumber = this.router.snapshot.queryParams.truckNumber;
    this.orderNumber = +this.router.snapshot.queryParams.orderNumber;

    if (!this.truckNumber || !this.orderNumber) {
      this.spinnerService.idle();
      this.hasError = true;
      return;
    }

    this.trackingService.getTransportDetails(this.orderNumber).subscribe({
      next: (response) => {
        if (response.Ok && !response.Obj.IsDelivered) {
          this.deliveryDateFrom = response.Obj.DateOfDelivery;
          const tempDate = new Date(this.deliveryDateFrom);
          tempDate.setHours(tempDate.getHours() + 2);
          this.deliveryDateTo = tempDate;
          this.trackingService.getTruckCoordinates(this.truckNumber).subscribe({
            next: (trackingResponse) => {
              if (trackingResponse.Lat && trackingResponse.Lng) {
                this.lat = trackingResponse.Lat;
                this.lng = trackingResponse.Lng;
                this.setIntervals();
                this.spinnerService.idle();
              } else {
                this.hasError = true;
                this.spinnerService.idle();
              }
            },
            error: (error) => {
              this.hasError = true;
              this.spinnerService.idle();
              console.log('Error from Motracking: ' + error);
            }
          });
        } else if (response.Ok && response.Obj) {
          this.isDelivered = true;
          this.spinnerService.idle();
        } else {
          this.hasError = true;
          this.spinnerService.idle();
        }
      },
      error: (error) => {
        this.hasError = true;
        this.spinnerService.idle();
        console.log(error);
      }
    });
  }

  setLanguage(): string {
    const language = navigator.language;
    if (language.includes('de')) {
      return 'DE';
    }
    if (language.includes('en')) {
      return  'EN';
    }
    if (language.includes('fr')) {
      return 'FR';
    }
    if (language.includes('it')) {
      return 'IT';
    }
    return 'EN';
  }

  setMessages() {
    switch (this.currentLanguage) {
      case 'DE':
        this.errorMessage = 'Leider ist ein Fehler aufgetreten und die Seite kann nicht angezeigt werden.';
        this.deliveryMessage = 'Besten Dank das Sie unser Service genutzt haben, Ihr Fahrzeug wurde ausgeliefert.';
        this.estimatedDeliveryMessage = 'Geplante Lieferzeit:';
        break;
      case 'FR':
        this.errorMessage = 'Malheureusement, une erreur s\'est produite et la page ne peut pas être affichée.';
        this.deliveryMessage = 'Merci d\'avoir utilisé notre service, votre véhicule a été livré.';
        this.estimatedDeliveryMessage = 'Délai de livraison prévu :';
        break;
      case 'IT':
        this.errorMessage = 'Purtroppo si è verificato un errore e la pagina non può essere visualizzata.';
        this.deliveryMessage = 'Grazie per aver utilizzato il nostro servizio, il suo veicolo è stato consegnato.';
        this.estimatedDeliveryMessage = 'Tempi di consegna previsti:';
        break;
      default:
      case 'EN':
        this.errorMessage = 'Unfortunately, an error has occurred and the page cannot be displayed.';
        this.deliveryMessage = 'Thank you for using our service, your vehicle has been delivered.';
        this.estimatedDeliveryMessage = 'Estimated Delivery:';
        break;
    }
  }

  checkDeliveredStatus() {
    this.trackingService.checkDeliveryStatus(this.orderNumber).subscribe({
      next: (response) => {
        if (response.Ok) {
          if (response.Obj) {
            this.isDelivered = true;
            this.clearIntervals();
          }
        } else {
          this.hasError = true;
          this.clearIntervals();
        }
      },
      error: (error) => {
        console.log(error);
        this.hasError = true;
        this.clearIntervals();
      }
    });
  }

  getTruckCoordinates(truckNumber: string) {
    this.trackingService.getTruckCoordinates(truckNumber).subscribe({
      next: (response) => {
        if (response.Lat && response.Lng) {
          this.lat = response.Lat;
          this.lng = response.Lng;
        } else {
          this.clearIntervals();
          this.hasError = true;
        }
      },
      error: (error) => {
        console.log(error);
        this.clearIntervals();
        this.hasError = true;
      }
    });
  }

  setIntervals() {
    this.motrackingInterval = setInterval(() => {
      this.checkDeliveredStatus();
    }, this.deliveryStatusIntervalTime);
    this.deliveryStatusInterval = setInterval(() => {
      this.getTruckCoordinates(this.truckNumber);
    }, this.motrackingIntervalTime);
  }

  clearIntervals() {
    clearInterval(this.deliveryStatusInterval);
    clearInterval(this.motrackingInterval);
  }

  @HostListener('window:resize', ['$event'])
  onResize(_) {
    this.height = window.innerHeight;
  }

  ngOnDestroy(): void {
    this.clearIntervals();
  }

}
